import random from "lodash/random";

// List of available rpc nodes to connect to
export const rpcNodes = [
  "https://mainnet.infura.io/v3/",
  "https://mainnet.infura.io/v3/",
  "https://mainnet.infura.io/v3/",
];

export const getRpcUrl = () => {
  const randomIndex = random(0, rpcNodes.length - 1);
  return rpcNodes[randomIndex];
};
